if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: true,
      filterTreeMobileStyle: 'style1',
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Add Item Grid Class
    itemHtml = itemHtml.replace(/{{itemGridClass}}/g, boostPFSThemeConfig.custom.item_grid_class);

    itemHtml = itemHtml.replace(/{{itemDynamicClass}}/g, boostPFSThemeConfig.custom.item_dynamic_class);

    console.log(boostPFSThemeConfig.custom.item_grid_class);
    
    if(data.images_info[0] != undefined) {
      var imageAspectRatio = data.images_info[0]['height'] * 100 / data.images_info[0]['width'];
      itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);
    }

    var itemHoverClass = '';
   
    
    if (images.length > 1) {
          itemHoverClass = 'has-hover';
     }
    
    itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, itemHoverClass);

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Labels
    var itemLabels = '';
    if (soldOut) {
      itemLabels = boostPFSTemplate.soldOutLabelHtml;
    } else if (onSale) {
      itemLabels = boostPFSTemplate.saleLabelHtml;
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabels);
    
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    

    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
    }

    // Flair
    itemHtml = itemHtml.replace(/{{itemFlairHtml}}/g, '<div data-flair-product-badge data-product-id="' + data.id.toString() + '"></div>');

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function bgset(image) {
      var bgset = '';
      if (image) {

          if (image.width >= 160) bgset += ' ' + Utils.optimizeImage(image.src, '160x') + ' 160w,';
          if (image.width >= 200) bgset += ' ' + Utils.optimizeImage(image.src, '200x') + ' 200w,';
          if (image.width >= 220) bgset += ' ' + Utils.optimizeImage(image.src, '220x') + ' 220w,';
          if (image.width >= 320) bgset += ' ' + Utils.optimizeImage(image.src, '320x') + ' 320w,';
          if (image.width >= 375) bgset += ' ' + Utils.optimizeImage(image.src, '375x') + ' 375w,';
          if (image.width >= 550) bgset += ' ' + Utils.optimizeImage(image.src, '550x') + ' 550w,';
          if (image.width >= 750) bgset += ' ' + Utils.optimizeImage(image.src, '750x') + ' 750w,';
          if (image.width >= 1100) bgset += ' ' + Utils.optimizeImage(image.src, '1100x') + ' 1100w,';
          if (image.width >= 1500) bgset += ' ' + Utils.optimizeImage(image.src, '1500x') + ' 1500w';
          
      }
      return bgset;
  }
var count = 0;
  function buildImages(data) {
    //console.log(data);
    count = count + 1;
    var html = '';
    if(count == boostPFSThemeConfig.custom.dynamic_index_one || count == boostPFSThemeConfig.custom.dynamic_index_two){
    //  console.log('if '+count+' = '+data.title);

      html += '<noscript><img srcset="' + bgset(images[3]) + '" sizes="auto" src="' + Utils.optimizeImage(images[3].src, '533x') + '" class=" motion-reduce" width="' + images[3]['width'] + '" height="auto" alt="{{itemTitle}}"> </noscript>'
          html += '<img ' +
                    'data-srcset="' + bgset(images[3]) + '" ' +
                    'data-sizes="auto" ' +
                    'data-src="' + Utils.optimizeImage(images[3].src, '533x') + '" ' +
                    'class=" lazyload no-js-hidden motion-reduce" ' +
                    'width="' + images[3]['width'] + '"' +
                    'height="' + images[3]['height'] + '"' +
                    'alt="{{itemTitle}}"' +
                    'data-primary-image ' +
                  '>';
          
          
          if (images.length > 4) {
            html += '<noscript><img srcset="' + bgset(images[3]) + '" sizes="auto" src="' + Utils.optimizeImage(images[3].src, '533x') + '" class=" motion-reduce" width="' + images[3]['width'] + '" height="auto" alt="{{itemTitle}}"> </noscript>'
            html += '<img ' +
                      'data-srcset="' + bgset(images[3]) + '" ' +
                      'data-sizes="auto" ' +
                      'data-src="' + Utils.optimizeImage(images[3].src, '533x') + '" ' +
                      'class=" lazyload no-js-hidden motion-reduce" ' +
                      'width="' + images[3]['width'] + '"' +
                      'height="' + images[3]['height'] + '"' +
                      'alt="{{itemTitle}}"' +
                      'data-secondary-image ' +
                    '>';
          }
            
    }
    else{   
     if( images.length > 0) {
     console.log('else '+count+' = '+data.title);
          html += '<noscript><img srcset="' + bgset(images[0]) + '" sizes="auto" src="' + Utils.optimizeImage(images[0].src, '533x') + '" class=" motion-reduce" width="' + images[0]['width'] + '" height="auto" alt="{{itemTitle}}"> </noscript>'
          html += '<img ' +
                    'data-srcset="' + bgset(images[0]) + '" ' +
                    'data-sizes="auto" ' +
                    'data-src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
                    'class=" lazyload no-js-hidden motion-reduce" ' +
                    'width="' + images[0]['width'] + '"' +
                    'height="' + images[0]['height'] + '"' +
                    'alt="{{itemTitle}}"' +
                    'data-primary-image ' +
                  '>';
          if (images.length > 1) {
            html += '<noscript><img srcset="' + bgset(images[1]) + '" sizes="auto" src="' + Utils.optimizeImage(images[1].src, '533x') + '" class=" motion-reduce" width="' + images[1]['width'] + '" height="auto" alt="{{itemTitle}}"> </noscript>'
            html += '<img ' +
                      'data-srcset="' + bgset(images[1]) + '" ' +
                      'data-sizes="auto" ' +
                      'data-src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
                      'class=" lazyload no-js-hidden motion-reduce" ' +
                      'width="' + images[1]['width'] + '"' +
                      'height="' + images[1]['height'] + '"' +
                      'alt="{{itemTitle}}"' +
                      'data-secondary-image ' +
                    '>';
          }

     }
    }
    
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var money_format = boostPFSThemeConfig.custom.show_currency_codes ? 'money_with_currency' : Globals.moneyFormat;
    var priceClass = '';
    if (soldOut) priceClass += ' price--sold-out ';
    if (onSale) priceClass += ' price--on-sale ';
    if (priceVaries && data.compare_at_price_min) priceClass += ' price--no-compare';
    html += '<div class="p2 p2--fixed medium price price--default product-card__price ' + priceClass + '">';
    if (soldOut) {
      html += '<div class="price__sold-out">' + boostPFSThemeConfig.label.sold_out + '</div>';
    } else if (priceVaries) {
      html += '<div class="price__from">' + boostPFSThemeConfig.label.from_price_html.replace('{{ price }}', Utils.formatMoney(data.price_min, money_format)) + '</div>';
    } else if (onSale) {
      html += '<del class="price__compare">' + Utils.formatMoney(data.compare_at_price_min, money_format) + '</del>';
      html += '<ins class="price__sale">' + Utils.formatMoney(data.price_min, money_format) + '</ins>';
    } else {
      html += '<span class="price__regular">' + Utils.formatMoney(data.price_min, money_format) + '</span>';
    }
    
    html += '</div>';
    return html;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    console.log(totalPage);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;

    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Build page items
    var currentPage = boostPFSThemeConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ size }}/g, totalPage);
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        var i = 1;
        for (var k in sortingArr) {
          var isSelected = ''
          if(paramSort == k) {
            isSelected = 'selected'
          }
          sortingItemsHtml += '<li class="list-menu__item facets__item"><label for="SortBy-mobile-' + Utils.slugify(k) + '-' + i + '" class="facet-checkbox">';
          sortingItemsHtml += '<input type="radio" name="sort_by" value="' + k + '" id="SortBy-mobile-' + Utils.slugify(k) + '-' + i + '" class="' + isSelected + '" >';
          sortingItemsHtml += sortingArr[k];
          sortingItemsHtml += '</label></li>';
          // sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
          i++;
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // ProductSorting.prototype.render = function () {
  //   jQ(Selector.topSorting).html(this.compileTemplate());

  //   if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
  //     jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
  //   }

  //   var labelSort = '';
  //   var paramSort = Globals.queryParams.sort || '';
  //   var sortingList = Utils.getSortingList();
  //   if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
  //     labelSort = sortingList[paramSort];
  //   } else {
  //     labelSort = Labels.sorting;
  //   }

  //   jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  // }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    jQ(Selector.topSorting + ' li').click(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).find('input').val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    this.buildExtrasProductListByAjax(data, 'boost-pfs-quickview', function(results) {
      results.forEach(function(result) {
        jQ('.grid__item[data-id="' + result.id + '"]').find('.product-card__form').html(result.quickview);
      });
      initQuickview();
    });


    // custom code
    count = 0;
    console.log("afterRender count = "+count);


    
  }

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    // Flair
    if (typeof FlairApp !== 'undefined' && FlairApp) { FlairApp.refreshProductBadges(); }

    var text = '';
    if (data.total_product == 1) {
      text = boostPFSThemeConfig.label.product_count_one;
    } else if (data.total_product > 1) {
      text = boostPFSThemeConfig.label.product_count_other;
    }
    jQ('.boost-pfs-filter-total-product').html(text.replace('{{ count }}', data.total_product));

    if (Utils.isMobile() && boostPFSFilterConfig.general.filterTreeMobileStyle == 'style1') {
      jQ('body').addClass('boost-pfs-filter-tree-open-body');
    }
  };

  /************************** END BUILD TOOLBAR **************************/
})();

function initQuickview () {
  if (!customElements.get('product-card')) {
    customElements.define('product-card', class ProductCard extends HTMLElement {
      constructor() {
        super();
  
        this.variantsSelect = this.querySelector('[data-product-select]');
        this.swatches = this.querySelectorAll('[data-swatches] input');
        this.media = this.querySelector('[data-product-media]');
        this.form = this.querySelector('form');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.quickviewTemplate = document.querySelector('#product-quickview');
        this.productTitle = this.dataset.productTitle;
        this.productId = this.dataset.productId;
  
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('change', this.onSwatchChange.bind(this));
        })
  
        if (this.variantsSelect) {
          this.variantsSelect.addEventListener('change', this.onVariantChange.bind(this));
        }

        this.form && this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
  
      onSwatchChange(event) {
        const optionSelector = `option[data-option${
          event.target.dataset.optionPosition
        }="${event.target.value}"]`;
  
        this.variantsSelect.value = this.variantsSelect.querySelector(optionSelector).value;
        this.variantsSelect.dispatchEvent(new Event('change'));
      }
  
      onVariantChange(event) {
        const selectedOption = event.target.selectedOptions[0];
  
        this.querySelectorAll('[data-product-link]').forEach((link) => {
          link.setAttribute('href', `${this.dataset.url}${selectedOption.value}`)
        })
  
        if (!selectedOption.dataset.imageSrc || !selectedOption.dataset.imageSrcset) {
          return;
        }
  
        this.media.classList.remove('has-hover');
        this.media.querySelector('[data-secondary-image]').style.display = 'none';
        this.media.querySelector('[data-primary-image]').src = selectedOption.dataset.imageSrc;
        this.media.querySelector('[data-primary-image]').srcset = selectedOption.dataset.imageSrcset;
      }
  
      onSubmit(event) {
        event.preventDefault();

        const submitter = event.target.querySelector('[type="submit"]');
        const dispatchSubmit = submitter.hasAttribute('data-url');
  
        if (!dispatchSubmit) {
          this.addItemToCart();
  
          return;
        }
  
        if (window.modals && window.modals[`Product-Quickview-${this.productId}`]) {
          const quickview = window.modals[`Product-Quickview-${this.productId}`];
  
          this.attachQuickview(submitter, quickview);
  
          return;
        }
  
        fetch(`${submitter.dataset.url}&variant=${this.variantsSelect.value}`)
          .then((response) => response.text())
          .then((responseText) => {
            this.buildQuickView(submitter, responseText);
          })
      }
  
      buildQuickView(submitter, responseText) {
        const productDetails = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('[data-product-details]');
        const productFeaturedMedia = Array.from(
          new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelectorAll('[data-product-media]')
        ).filter((media) => media.children[0].tagName.toLowerCase() !== 'modal-opener' && media.children[0].tagName.toLowerCase() !== 'deferred-media');
        const quickview = this.quickviewTemplate.content.cloneNode(true).querySelector('.product-quickview');
  
        quickview.id = `${quickview.id}${this.productId}`;
        quickview.querySelectorAll('[data-modal-close]').forEach((element) => {
          element.id = `${element.id}${this.productId}`;
        });
  
        if (quickview.querySelector('[role="dialog"]').ariaLabel) {
          quickview.querySelector('[role="dialog"]').ariaLabel =
            quickview.querySelector('[role="dialog"]').ariaLabel.replace('{{ product_title }}', this.productTitle);
        }
  
        productFeaturedMedia.forEach((media, index) => {
          media.children[0].setAttribute('data-product-quickview-media', '');
  
          if (index === 0) {
            return;
          }
  
          media.children[0].style.display = 'none';
        });
        quickview.querySelector('[data-media-wrapper]').innerHTML = Array.from(productFeaturedMedia).map((media) => media.innerHTML).join('');
        quickview.querySelector('[data-details-wrapper]').innerHTML = productDetails.innerHTML;
  
        this.attachQuickview(submitter, quickview);
      }
  
      attachQuickview(submitter, quickview) {
        document.body.append(quickview);
        setTimeout(() => {
          quickview.show(submitter);
        }, 1);
      }
  
      addItemToCart() {
        if (!this.cartDrawer) {
          this.form && this.form.submit()
  
          return;
        }
  
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
  
        const formData = new FormData(this.form);
        formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
  
        this.cartDrawer.setActiveElement(document.activeElement);
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.console.error(response.status);
  
              return;
            }
  
            this.cartDrawer.handleAddedItem(response);
          })
          .catch((error) => {
            window.console.error(error);
          });
      }
    });
  }
}
